import { CheckCircle, FileText, PiggyBank, XCircle } from "lucide-react";
import { KpiCard, KpiGrid } from "../KpiCard";
import type { DecisionDashboard } from "../../api/claimsApi";

type Formatter = (value: number | null | undefined) => string;

function plural(count: number, word: string): string {
  return `${count} ${word}${count > 1 ? "s" : ""}`;
}

/** Demandes de validation de la période : toutes, économies, approuvées et rejetées, avec leurs montants. */
export function InsurerRequestsBlock({ requests, formatMoney }: { requests: DecisionDashboard["requests"]; formatMoney: Formatter }) {
  const usd = (value: number) => `${formatMoney(value)} USD`;

  return (
    <section className="theme-card p-5 sm:p-6">
      <p className="mb-3 text-[11px] font-semibold uppercase tracking-[0.12em] text-muted-foreground">Demandes de validation</p>
      <KpiGrid className="grid-cols-1 sm:grid-cols-2 xl:grid-cols-4">
        <KpiCard
          tone="purple"
          icon={FileText}
          label="Toutes les demandes"
          value={usd(requests.total_amount)}
          hint={`${plural(requests.total, "demande")} · ${plural(requests.total_acts, "acte")}`}
          href="/dashboard/requests"
        />
        <KpiCard
          tone="amber"
          icon={PiggyBank}
          label="Économies réalisées"
          value={usd(requests.savings)}
          hint={`Soit ${requests.savings_rate.toLocaleString("fr-FR")} % des demandes approuvées`}
          href="/dashboard/requests/refactions"
        />
        <KpiCard
          tone="mint"
          icon={CheckCircle}
          label="Demandes approuvées"
          value={usd(requests.approved_amount)}
          hint={`${plural(requests.approved, "demande")} · ${plural(requests.approved_acts, "acte")}`}
          href="/dashboard/requests?status=approved"
        />
        <KpiCard
          tone="red"
          icon={XCircle}
          label="Demandes rejetées"
          value={usd(requests.rejected_amount)}
          hint={plural(requests.rejected, "demande")}
          href="/dashboard/requests?status=rejected"
        />
      </KpiGrid>
    </section>
  );
}
